import { render, staticRenderFns } from "./heatnews.vue?vue&type=template&id=2b4b6cb2&scoped=true&"
import script from "./heatnews.vue?vue&type=script&lang=js&"
export * from "./heatnews.vue?vue&type=script&lang=js&"
import style0 from "./heatnews.vue?vue&type=style&index=0&id=2b4b6cb2&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4b6cb2",
  null
  
)

export default component.exports